import * as types from './mutation-types'

export default {
  [types.ADD_ACCOMPANIMENTS](state, data) {
    state.accompaniments = data
  },
  [types.ADD_ACCOMPANIMENT] (state, data) {
    state.accompaniments.push(data)
  },
}
